import {Sidebar} from 'react-admin';
import {makeStyles} from '@mui/styles';
import React from "react";

const useSidebarStyles = makeStyles(theme=> ({
    paper: {
        backgroundColor: theme.palette.primary.main,
        minHeight: '100vh',
        height: '100%',
        marginTop: 0,
        overflowX: 'hidden',
    },
}));

const MySidebar = props => {
    const classes = useSidebarStyles();
    return (
        <Sidebar classes={classes} {...props} />
    );
};

export default MySidebar;
